<template>
  <div>
    <v-snackbar
      :color="snackbarColor"
      absolute
      top
      :timeout="3000"
      v-model="snackbar"
      >{{ snackbarText }}</v-snackbar
    >

    <v-card :loading="loading" :disabled="loading">
      <v-card-title>
        <h2>{{ selectedItem ? "Editar punto" : "Agregar punto" }}</h2>
        <v-btn
          style="right: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
        >
          <v-icon dark style="font-size: 20px">fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="point.name"
                rounded
                :maxlength="40"
                :loading="loading"
                @keypress="validString"
                filled
                hide-details
                :class="{ errorC: validation && !point.name }"
                label="Nombre del punto"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-select
                hide-details
                v-model="point.type"
                :class="{ errorC: validation && !point.type }"
                filled
                :items="types"
                rounded
              />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="point.contactName"
                rounded
                hide-details
                :maxlength="40"
                @keypress="validString"
                :loading="loading"
                :class="{ errorC: validation && !point.contactName }"
                filled
                label="Nombre del contacto"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model.number="point.contactPhone"
                rounded
                hide-details
                @keypress="isNumber"
                :maxlength="20"
                :loading="loading"
                filled
                :class="{ errorC: validation && !point.contactPhone }"
                label="Número de teléfono"
              >
              </v-text-field>
            </v-col>

            <v-col style="height: 40vh" cols="12" sm="12" md="12">
              <map-c
                v-if="showMap"
                @updated="locationUpdated"
                :latitude="latitude"
                :longitude="longitude"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-row align="center" class="d-flex mb-0 mx-2">
          <v-col cols="6" sm="8" md="8">
            <v-switch
              :loading="loading"
              v-model="point.active"
              label="Activo"
            />
          </v-col>

          <v-col cols="6" sm="4" md="4">
            <v-btn
              color="primary"
              rounded
              class="flex-grow-1 ml-2"
              large
              :elevation="0"
              :minHeight="50"
              :disabled="loading"
              @click="save"
              block
            >
              Aceptar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db, fb } from "@/firebase";
import mapC from "@/components/map-geofence";

export default {
  name: "add-point",
  components: {
    mapC,
  },
  props: ["selectedItem", "businessId"],
  data() {
    return {
      loading: true,
      snackbarText: "",
      snackbarColor: "",
      snackbar: false,
      validation: false,
      latitude: "14.0839129",
      longitude: "-87.2399923",
      showMap: false,
      point: {
        name: "",
        contactName: "",
        contactPhone: "",
        active: true,
        type: "startingPoint",
      },
      types: [
        { text: "Punto Inicial", value: "startingPoint" },
        { text: "Punto Secundario", value: "secondaryPoint" },
        { text: "Punto Inicial y Secundario", value: "both" },
      ],
    };
  },
  computed: {
    ...mapState(["user"]),
  },

  methods: {
    validString(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        (charCode > 64 && charCode < 91) ||
        (charCode > 96 && charCode < 123) ||
        charCode == 8 ||
        charCode == 32
      )
        return true;
      else {
        // return false;
        evt.preventDefault();
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        (charCode > 31 && (charCode < 48 || charCode > 57)) ||
        charCode == 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    locationUpdated(e) {
      this.latitude = e[0];
      this.longitude = e[1];
    },
    updateLocation(subcollectionId) {
      return new Promise((resolve, reject) => {
        let data = {
          collection: "businessesCorporative",
          subcollection: "points",
          collectionId: this.businessId,
          subcollectionId,
          latitude: this.latitude,
          longitude: this.longitude,
        };

        var httpGeneralUpdateGeoPoint = fb
          .functions()
          .httpsCallable("httpGeneralUpdateGeoPoint");
        httpGeneralUpdateGeoPoint(data)
          .then(() => {
            resolve("success");
          })
          .catch((err) => {
            this.loading = false;
            this.snackbar = true;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente";
          });
      });
    },
    save() {
      this.validation = true;

      if (
        !this.point.name &&
        !this.point.contactName &&
        !this.point.contactPhone
      ) {
        this.snackbarText = "Ingrese los campos que son obligatorios.";
        this.snackbar = true;
        this.snackbarColor = "red darken-2";

        return;
      }

      if (!this.point.name) {
        this.snackbarText = "Ingrese el nombre del punto.";
        this.snackbar = true;
        this.snackbarColor = "red darken-2";

        return;
      }

      if (!this.point.contactName) {
        this.snackbarText = "Ingrese el nombre del contacto.";
        this.snackbar = true;
        this.snackbarColor = "red darken-2";

        return;
      }

      if (!this.point.contactPhone) {
        this.snackbarText = "Ingrese el teléfono del contacto.";
        this.snackbar = true;
        this.snackbarColor = "red darken-2";

        return;
      }

      this.loading = true;

      let data = {
        name: this.point.name,
        active: this.point.active ? this.point.active : false,
        contactName: this.point.contactName ? this.point.contactName : "",
        contactPhone: this.point.contactPhone ? this.point.contactPhone : "",
        deleted: false,
        type: this.point.type ? this.point.type : "both",
      };

      let query = db
        .collection("businessesCorporative")
        .doc(this.businessId)
        .collection("points");

      if (this.selectedItem) {
        data.modifiedAt = new Date();
        data.modifiedBy = this.user[".key"];
        query = query.doc(this.selectedItem[".key"]).update(data);
      } else {
        data.createdAt = new Date();
        data.createdBy = this.user[".key"];
        query = query.add(data);
      }

      query
        .then(async (ref) => {
          await this.updateLocation(ref ? ref.id : this.selectedItem[".key"]);

          this.loading = false;

          this.$emit("success");
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbarColor = "red darken-2";
          this.snackbar = true;
        });
    },
  },

  mounted() {
    if (this.selectedItem) {
      this.point = Object.assign({}, this.selectedItem);

      if (this.point.address && this.point.address.geopoint) {
        this.latitude = this.point.address.geopoint.latitude;
        this.longitude = this.point.address.geopoint.longitude;
      }
    }

    this.loading = false;
    this.showMap = true;
  },
};
</script>


<style>
.leaflet-control-zoom.leaflet-bar a:first-child {
  border-radius: 50%;
}

.leaflet-touch .leaflet-bar a:last-child {
  border-radius: 50%;
}
.leaflet-control-zoom.leaflet-bar {
  border: 0;
}

.errorC {
  border: 1px solid red;
}
</style>